import {
  EditOrderRecipientDialogContainer,
  EditRecipientContainer,
  RecipientSelectRadioGroup,
} from "./styled";
import { Divider } from "@mui/material";
import { Recipient } from "../../../../shared/models/user/recipient/recipient";
import BarekamText from "../../../../components/text";
import { RecipientActionButtonContainer } from "../../../../user/settings/recipients/edit-recipient/styled";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux/store";
import {
  Message,
  MessageSections,
} from "../../../../components/message/message";
import BarekamButton, {
  DialogButtons,
  OrderButtons,
} from "../../../../components/button";
import { SingleSelectItem } from "../../../../components/single-select-item/single-select-item";
import { getMyRecipients } from "../../../../../redux/slices/recipients.slice";
import { onRecipientChange } from "../../../../../services/orders.service";
import { StandardDialog } from "../../../../components/dialogs/standard-dialog/standard-dialog";
import EditRecipient from "../../../../user/settings/recipients/edit-recipient";

export const EditOrderRecipientDialog = (props: OrderDetailProps) => {
  const { onClose, open, selectedRecipient } = props;
  const [newRecipient, setNewRecipient] =
    useState<Recipient>(selectedRecipient);
  const [popupOpened, setPopupOpened] = React.useState(false);

  const dispatch = useAppDispatch();

  const { myRecipientsData } = useAppSelector(
    (state) => state.recipientDataReducer,
  );

  const handleClose = () => {
    onClose(undefined);
  };

  const handleSave = () => {
    if (selectedRecipient.recipientId === newRecipient?.recipientId) {
      handleClose();
    } else {
      onClose(newRecipient);
    }
  };

  const handleChange = (recipient: Recipient) => {
    setNewRecipient(recipient);
  };

  function onNewRecipientClicked() {
    setPopupOpened(true);
  }

  function onNewRecipientPopupClose(recipientData: { id: number } | null) {
    if (!!recipientData) {
      dispatch(getMyRecipients({ forceLoad: true })).then((response) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const recipients = response.payload?.myRecipients?.recipients || [];
        const addedRecipient = recipients.find(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (recipient) => recipient.recipientId === recipientData.id,
        );
        onRecipientChange(addedRecipient, dispatch);
        setNewRecipient(addedRecipient);
      });
    }
    setPopupOpened(false);
  }

  return (
    <EditOrderRecipientDialogContainer onClose={handleClose} open={open}>
      <EditRecipientContainer>
        <BarekamText variant={"xl"} fontWeight={700}>
          <Message
            messageKey={"select_recipient"}
            sectionId={MessageSections.ORDERS}
          />
        </BarekamText>

        <Divider style={{ width: "100%" }} />

        <RecipientSelectRadioGroup
          row
          name="order_recipient"
          value={newRecipient?.recipientId}
        >
          {myRecipientsData.recipients.map((recipient) => (
            <SingleSelectItem
              TopLabel={
                <BarekamText variant={"m"} fontWeight={500}>
                  {recipient.firstName} {recipient.lastName}
                </BarekamText>
              }
              LowerLabel={
                <BarekamText variant={"s"} fontWeight={600} opaque>
                  +{recipient.phoneNumber}
                </BarekamText>
              }
              onClick={() => handleChange(recipient)}
              selected={recipient.recipientId === newRecipient?.recipientId}
              key={recipient.recipientId}
            />
          ))}
        </RecipientSelectRadioGroup>

        <BarekamButton
          type={OrderButtons.ADD_PRODUCT}
          onClick={() => onNewRecipientClicked()}
        >
          <BarekamText variant={"xxl"} width={"unset"}>
            +
          </BarekamText>

          <BarekamText variant={"m"} bold>
            <Message
              messageKey={"add_new_recipient"}
              sectionId={MessageSections.ORDERS}
            />
          </BarekamText>
        </BarekamButton>

        <Divider style={{ width: "100%" }} />

        <RecipientActionButtonContainer>
          <BarekamButton
            type={DialogButtons.CANCEL}
            onClick={() => handleClose()}
          >
            <BarekamText variant={"s"} fontWeight={500}>
              <Message messageKey={"cancel"} sectionId={MessageSections.USER} />
            </BarekamText>
          </BarekamButton>

          <BarekamButton type={DialogButtons.SAVE} onClick={() => handleSave()}>
            <BarekamText variant={"s"} fontWeight={700}>
              <Message messageKey={"ok"} sectionId={MessageSections.USER} />
            </BarekamText>
          </BarekamButton>
        </RecipientActionButtonContainer>
      </EditRecipientContainer>

      <StandardDialog
        headerLabel={
          <Message
            messageKey={"new_recipient"}
            sectionId={MessageSections.USER}
          />
        }
        open={popupOpened}
      >
        <EditRecipient
          recipient={
            {
              firstName: "",
              lastName: "",
              phoneNumber: "",
              passportOrIdSerialNumber: "",
              documentExpirationDate: null,
              address: "",
            } as Recipient
          }
          recipientSaved={(recipientId: any) =>
            onNewRecipientPopupClose(recipientId)
          }
          popupClosed={() => onNewRecipientPopupClose(null)}
        />
      </StandardDialog>
    </EditOrderRecipientDialogContainer>
  );
};

interface OrderDetailProps {
  open: boolean;
  selectedRecipient: Recipient;
  onClose: (value: Recipient | undefined) => void;
}
